import { useMemo } from 'react';
import type { AvailableQuantityItem } from '../types';
import { escapeRegex, getStoreAvailableQuantity } from '../utils';

interface UseFilteredStoresParams {
  stores: any[];
  searchValue: string;
  nameKeys: readonly string[];
  isShowAvailableQuantity?: boolean;
  availableQuantity?: AvailableQuantityItem[];
}

const useFilteredStores = ({
  stores,
  searchValue,
  nameKeys,
  isShowAvailableQuantity,
  availableQuantity
}: UseFilteredStoresParams): any[] =>
  useMemo(() => {
    const re = new RegExp(escapeRegex(searchValue), 'i');
    const matched = stores.filter(item =>
      nameKeys.some(key => re.test(String(item?.[key] ?? '')))
    );

    if (isShowAvailableQuantity && availableQuantity?.length) {
      return matched.filter(item => {
        const quantity = getStoreAvailableQuantity(item.id, availableQuantity);
        return !!quantity && quantity > 0;
      });
    }

    return matched;
  }, [
    stores,
    searchValue,
    isShowAvailableQuantity,
    availableQuantity,
    nameKeys
  ]);

export default useFilteredStores;
